import { Component, output } from '@angular/core';

@Component({
  selector: 'app-confirmation-close',
  imports: [],
  templateUrl: './confirmation-close.html',
  styleUrl: './confirmation-close.scss',
})
export class ConfirmationClose {
  onCancel = output();
  closeModal = output();

  onCloseModal() {
    this.closeModal.emit();
  }

  onSubmit() {
    this.onCancel.emit();
  }
}
